import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import * as _ from "lodash";
import { LoadingBarService } from "@ngx-loading-bar/core";

import { HeaderService, EquipmentsService } from "../../../shared";

@Component({
  selector: "app-equipments-list",
  templateUrl: "./equipments-list.component.html",
  styleUrls: ["./equipments-list.component.scss"],
})
export class EquipmentsListComponent implements OnInit {
  typeComponent = "equipments";

  textBtnNew = "Novo Equipamento";
  urlBtnNew = "/panel/equipments/new";

  currentUrl = "/panel/equipments";

  dataList;

  pag;
  filters;
  cacheObj;

  equipmentRequest;

  totalEquipments;

  constructor(
    private headerService: HeaderService,
    private equipmentsService: EquipmentsService,
    private loadingBarService: LoadingBarService,
    private activatedRoute: ActivatedRoute
  ) {
    if (this.activatedRoute.snapshot.params.pag) {
      this.pag = this.activatedRoute.snapshot.params.pag;
    } else {
      this.pag = 1;
    }
  }

  ngOnInit() {
    this.headerService.changeTitle("Equipamentos");

    this.headerService.changeSubtitle("");

    this.headerService.changeDatePicker(false);

    this.dataList = {};

    this.translateFilter();
  }

  equipmentList(filters = "") {
    this.loadingBarService.stop();

    this.loadingBarService.start();

    if (this.equipmentRequest) {
      this.equipmentRequest.unsubscribe();
    }

    this.equipmentRequest = this.equipmentsService
      .listEquipments(filters)
      .subscribe((response) => {
        this.loadingBarService.complete();

        this.dataList = response;

        this.totalEquipments = response["total"];
      });
  }

  setPag(setPag) {
    this.pag = setPag;

    this.translateFilter();
  }

  translateFilter(obj?) {
    this.filters = [];

    if (obj) {
      this.cacheObj = obj;
    }

    _.forOwn(this.cacheObj, (value, key) => {
      this.filters.push(`${key}=${value}`);
    });

    this.equipmentList(`?pageNumber=${this.pag}&` + this.filters.join("&"));
  }
}
